<div class="email-modal">
  <header class="modal-header">
    <h2>General email</h2>
    <button class="icon-close" type="button" (click)="close()"
      aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </header>
</div>